import * as contentSchema from "#schema";

export { contentRelations } from "#relations";

export type AppGraphemeMeaningCard = typeof contentSchema.appGraphemeMeaningCard.$inferSelect;
export type AppGraphemeMeaningCardDescription =
  typeof contentSchema.appGraphemeMeaningCardDescription.$inferSelect;
export type AppGraphemePronunciationCard =
  typeof contentSchema.appGraphemePronunciationCard.$inferSelect;

export type ContentTables = {
  [$Key in keyof typeof contentSchema]: (typeof contentSchema)[$Key]["$inferSelect"][];
};
